import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { SessionStoreRepository } from '../../shared/repositories/session.repository';
import { easeInAnimation500 } from '../../shared/animations/easeInAnimations';
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
    selector: 'app-reception',
    imports: [TranslocoDirective],
    templateUrl: './reception.component.html',
    styleUrl: './reception.component.scss',
    animations: [easeInAnimation500]
})
export class ReceptionComponent {
    private readonly router = inject(Router);
    private readonly sessionRepository = inject(SessionStoreRepository);
    private isPatient: boolean = this.sessionRepository.isPatient;

    ngOnInit(): void {
        if (!this.isPatient || !environment.checkFogpForms) {
                this.router.navigate(["/schemas"]);
        }
    }

  onSchemaClick(){
    this.router.navigate(["/schemas"]);
  }

  onFogpFormsClick(){
    window.location.href = environment.fogpRedirectUrl;
  }

}
